module.exports = __webpack_public_path__ + "static/media/step-1.f4fc372b.png";